import styled from 'styled-components'
import { Card } from 'react-bootstrap'
import fontsSizes from '../../const/fonts'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface ListGroupWrapperProps {
  isMobileMenuOpen?: boolean
}
export const ListGroupWrapper = styled.li<ListGroupWrapperProps>`
  margin: 16px 0;
  z-index: ${({ isMobileMenuOpen }) => (isMobileMenuOpen ? '-1' : '1')};
  list-style: none;
`

export const CardItem = styled(Card)`
  height: 75px;
  background: ${({ theme }) => theme.list?.background} !important;
  display: flex;
  flex-direction: row;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.list?.border};
  cursor: pointer;
`

export const ListPrefix = styled.span`
  padding: 8px;
  border-radius: 5px;
  background: none;
  margin: auto 8px;
  font-size: ${fontsSizes.large}px;
`

export const CardWrapper = styled.div`
  margin: auto 12px;
`

export const Chevron = styled(FontAwesomeIcon)`
  float: right;
  margin: auto;
  margin-left: auto;
  margin-right: 16px;
`

export const CardTitle = styled(Card.Title)`
  overflow: hidden;
  max-height: 45px;
  text-overflow: ellipsis;
  color: ${({ theme }) => theme.card.title.color};
`
